<template>
  <div>
    <div class="tw-text-gray-800 tw-flex">
      <money-format :value="event.amount" :locale="locale" subunits-value />
      &nbsp;{{ title }}
    </div>
    <div class="tw-text-gray-500 tw-text-xs">
      {{ event.label }}
    </div>
    <div v-if="event.amountRefunded" class="tw-flex tw-text-gray-500 tw-text-xs">
      <money-format :value="event.amountRefunded" :locale="locale" subunits-value />&nbsp;Refunded
      <span class="tw-mx-1">&#x2022;</span>
      <money-format :value="event.amount - event.amountRefunded" :locale="locale" subunits-value />&nbsp;Remaining
    </div>
    <base-button class="tw-mt-1" type="text" size="xs" @click="$emit('refundCharge', event)" v-if="showRefund === true">Refund</base-button>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";
import { startCase } from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {
    MoneyFormat,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("role", ["isLocationFiltered"]),
    locale() {
      return window.navigator.language;
    },
    title() {
      return startCase(this.event.type);
    },
    showRefund() {
      return this.event.amount > this.event.amountRefunded && this.event.type.toLowerCase() !== "charge failed" && !this.isLocationFiltered;
    },
  },
};
</script>
